import { Quote, TokenList, SwapTx, ApprovalTx, Allowance } from "@cede/types";
import { GetTokenList, GetQuote, GetSwapTx, GetApprovalTx, GetAllowance } from "../swap.types";

const apiUrl = "https://api.1inch.io/v5.0";

export const getTokenList: GetTokenList = async (params) => {
  const { chainId } = params;
  const response = await fetch(`${apiUrl}/${chainId}/tokens`);
  return (await response.json()) as Promise<TokenList>;
};

export const getQuote: GetQuote = async (params) => {
  const { tokenFrom, tokenTo, amount, chainId } = params;
  const url = `${apiUrl}/${chainId}/quote?fromTokenAddress=${tokenFrom}&toTokenAddress=${tokenTo}&amount=${amount}`;
  const response = await fetch(url);
  return (await response.json()) as Promise<Quote>;
};

export const getSwapTx: GetSwapTx = async (params) => {
  const { tokenFrom, tokenTo, fromAddress, amount, slippage, chainId } = params;
  const url = `${apiUrl}/${chainId}/swap?fromTokenAddress=${tokenFrom}&toTokenAddress=${tokenTo}&amount=${amount}&fromAddress=${fromAddress}&slippage=${slippage}`;
  const response = await fetch(url);
  const txResponse = await response.json();
  txResponse.tx.gasLimit = txResponse.tx.gas;
  delete txResponse.tx.gas;
  return txResponse.tx as SwapTx;
};

export const getApprovalTx: GetApprovalTx = async (params) => {
  const { tokenAddress, chainId, amount } = params;
  const url = `${apiUrl}/${chainId}/approve/transaction?tokenAddress=${tokenAddress}&amount=${amount}`;
  const response = await fetch(url);
  return (await response.json()) as Promise<ApprovalTx>;
};

export const getAllowance: GetAllowance = async (params) => {
  const { tokenAddress, ownerAddress, chainId } = params;
  const url = `${apiUrl}/${chainId}/approve/allowance?tokenAddress=${tokenAddress}&walletAddress=${ownerAddress}`;
  const response = await fetch(url);
  return (await response.json()) as Promise<Allowance>;
};
